import { Controller } from '@hotwired/stimulus';

export default class ListStyleController extends Controller {
    changeStyle(event) {
        document.cookie = `listStyle=${event.params.style}; path=/; max-age=34560000`;
    }
}
